const NEAR_LIMIT_RATIO = 0.8;
const NEAR_LIMIT_REMAINING = 3;

const toNumber = (value, fallback = 0) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : fallback;
};

export const normalizeDelayedOperationQuota = (quota, {requested = null} = {}) => {
    if (!quota || typeof quota !== 'object') {
        return null;
    }
    const limit = Math.max(toNumber(quota.limit), 0);
    const used = Math.max(toNumber(quota.used), 0);
    const remaining = Math.max(toNumber(quota.remaining, limit - used), 0);
    const requestedCount = Math.max(toNumber(requested ?? quota.requested), 0);
    const rawAllowed = quota.allowed ?? quota.is_allowed;
    const allowed = rawAllowed !== false && requestedCount <= remaining;
    return {
        limit,
        used,
        remaining,
        requested: requestedCount,
        allowed,
    };
};

export const getDelayedOperationQuotaStatus = (quota, options = {}) => {
    const normalized = normalizeDelayedOperationQuota(quota, options);
    if (!normalized) {
        return null;
    }
    if (normalized.remaining <= 0) {
        return {
            ...normalized,
            status: 'exhausted',
        };
    }
    if (!normalized.allowed || normalized.requested > normalized.remaining) {
        return {
            ...normalized,
            status: 'exceeded',
        };
    }
    if (
        normalized.limit > 0
        && (
            normalized.used / normalized.limit >= NEAR_LIMIT_RATIO
            || normalized.remaining <= NEAR_LIMIT_REMAINING
        )
    ) {
        return {
            ...normalized,
            status: 'near',
        };
    }
    return {
        ...normalized,
        status: 'normal',
    };
};

export const shouldShowDelayedOperationQuotaWarning = (quota, options = {}) => {
    const status = getDelayedOperationQuotaStatus(quota, options);
    return Boolean(status && status.status !== 'normal');
};
